/* libs */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

/* components */
import Page from "../../shared/Page";
import GridFormSwitcher from "../../shared/GridFormSwitcher";
import Grid from "../../shared/Grid";
import ThemeFormWrapper from "./ThemeFormWrapper";

/* helpers */
import * as globalActions from "../../../actions/globalActions";
import * as themesActions from "../../../actions/themesActions";

class ThemesPage extends Component {
	constructor(props) {
		super(props);
		this.renderGrid = this.renderGrid.bind(this);
		this.appKey = props.match.params.appKey;

		this.state = {
			hasFormApi: false,
			formApi: null,
		};
	}

	componentDidMount() {
		this.props.actions.getThemes(this.appKey);
	}

	// deleteTheme(theme){
	// 	this.props.actions.deleteTheme(theme, this.appKey);
	// }

	getAppId = key => {
		const { apps } = this.props;
		const app = apps.find(a => a.key === key);
		return app.id;
	};

	getFormApi = formApi => {
		this.setState({ formApi, hasApi: true });
	};

	reloadThemes = () => {
		const { actions, history } = this.props;
		actions.getThemes(this.appKey);
		history.push(`/apps/${this.appKey}/themes`);
	};

	logError = error => {
		//alert("Boo...");
		console.log(">>>: ", JSON.stringify(error));
		//this.props.validationActions.updateFormErrors(error.response.data.Errors);
		/*error.response.data.Errors.forEach((error) => {
			this.state.formApi.setError(error.Key, error.Value);
		});*/
	};

	createItem = (values, submitHandler) => {
		const { globalActions } = this.props;
		const data = {
			...values,
			appId: this.getAppId(this.appKey),
		};
		globalActions.createItem(data, "/themes", this.reloadThemes, this.logError, submitHandler);
	};

	updateItem = (values, submitHandler, itemId) => {
		//TODO: item to update has be different than what will be sent out
		const { globalActions } = this.props;
		globalActions.updateItem(values, `/themes/${itemId}`, this.reloadThemes, this.logError, submitHandler);
	};

	copyItem = (values, submitHandler) => {
		const { globalActions } = this.props;
		const data = {
			...values,
			appId: this.getAppId(this.appKey),
		};
		globalActions.createItem(data, "/themes", this.reloadThemes, this.logError, submitHandler);
	};

	deleteItem = (id, name) => {
		let appKey = this.appKey;
		const { actions, globalActions } = this.props;
		const onSuccess = () => {
			actions.getThemes(appKey);
		};
		globalActions.deleteItem(`/themes/${id}`, onSuccess, this.logError, name);
	};

	loadTheme = themeId => {
		const { actions } = this.props;
		actions.loadTheme(themeId);
	};

	/* populate grid */

	renderGrid() {
		const { themes } = this.props.themes;
		// const defaultText = themes;
		return (
			<div>
				{themes ? (
					<Grid
						// defaultText={defaultText}
						pluralItemName="themes"
						items={themes}
						data={this.props}
						delete={this.deleteItem}
					/>
				) : (
					<h1>Loading...</h1>
				)}
			</div>
		);
	}

	render() {
		return (
			<Page title="Themes">
				<GridFormSwitcher
					RenderCopy={ThemeFormWrapper}
					RenderEdit={ThemeFormWrapper}
					RenderNew={ThemeFormWrapper}
					renderGrid={this.renderGrid}
					createItem={this.createItem}
					updateItem={this.updateItem}
					copyItem={this.copyItem}
					getSingleItem={this.loadPage}
					getFormApi={this.getFormApi}
					hasFormApi={this.state.hasFormApi}
				/>
			</Page>
		);
	}
}

const mapStateToProps = state => ({
	themes: state.themes,
	apps: state.apps.apps,
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(themesActions, dispatch),
	globalActions: bindActionCreators(globalActions, dispatch),
});

ThemesPage.propTypes = {
	themes: PropTypes.object,
	actions: PropTypes.object,
	history: PropTypes.object,
	match: PropTypes.object,
	globalActions: PropTypes.object,
	apps: PropTypes.array,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ThemesPage);
